/**
 * Wait for all promises completion, even if one throws an errror
 * @param {Promise<any>[]} requests Array of promises
 * @return {Promise<any[]>} Array of values
 */
export const completePromises = async (requests: Promise<any>[]): Promise<any[]> => (
  (await Promise.allSettled(requests)).map((item) => (item as any).value)
);
